import type { Lang } from '../i18n'

/**
 * The header and footer, which are the same on every page.
 *
 * The footer's sibling line is where Ronin points at DiabetesNinja. diabetesninja.se points
 * back from a box on its start page and a line in its footer.
 */

export type LayoutCopy = {
  skipToContent: string
  navHome: string
  navFeatures: string
  navAbout: string
  navContact: string
  navNews: string
  navPrivacy: string
  navTerms: string
  langLabel: string

  footerBlurb: string
  footSiblingLead: string
  footSiblingLink: string
  footAppTitle: string
  footLegalTitle: string
  footContactTitle: string
  footOrgLine: string
  footRights: string
  footNotDevice: string
}

const en: LayoutCopy = {
  skipToContent: 'Skip to content',
  navHome: 'Home',
  navFeatures: 'Features',
  navAbout: 'About',
  navContact: 'Contact',
  navNews: "What's new",
  navPrivacy: 'Privacy',
  navTerms: 'Terms and conditions',
  langLabel: 'Language',

  footerBlurb: 'A diary for adults with type 1 diabetes. Free, with nothing to buy inside it.',
  footSiblingLead: 'Ronin is the grown-up sibling of DiabetesNinja, the diabetes app for children, from the same people:',
  footSiblingLink: 'diabetesninja.se',
  footAppTitle: 'The app',
  footLegalTitle: 'Legal',
  footContactTitle: 'Contact',
  footOrgLine: 'Published by',
  footRights: '© 2026',
  footNotDevice: 'Ronin is a diary, not a medical device.',
}

const sv: LayoutCopy = {
  skipToContent: 'Hoppa till innehållet',
  navHome: 'Hem',
  navFeatures: 'Funktioner',
  navAbout: 'Om',
  navContact: 'Kontakt',
  navNews: 'Nyheter',
  navPrivacy: 'Integritet',
  navTerms: 'Villkor',
  langLabel: 'Språk',

  footerBlurb: 'En dagbok för vuxna med typ 1-diabetes. Gratis, utan något att köpa inuti.',
  footSiblingLead: 'Ronin är den vuxna syskonappen till DiabetesNinja, diabetesappen för barn, från samma personer:',
  footSiblingLink: 'diabetesninja.se',
  footAppTitle: 'Appen',
  footLegalTitle: 'Juridik',
  footContactTitle: 'Kontakt',
  footOrgLine: 'Utges av',
  footRights: '© 2026',
  footNotDevice: 'Ronin är en dagbok, inte en medicinteknisk produkt.',
}

export const layoutCopy: Record<Lang, LayoutCopy> = { sv, en }
